import React, { useRef, useState, useContext, useEffect } from 'react'
import { each, get, has, isEmpty } from 'lodash'
import { BookInfo } from '../../contexts/menuContext'
import { getRelation } from '../../api/getRelation'
import { useHistory } from 'react-router-dom'

const IndexMenu = ({ navigationOnly }) => {
  const indexMenuData = useRef(null)
  const [book, setBook, , setPage, , setForceScroll] = useContext(BookInfo)
  const [search, setSearch] = useState('')
  const [index, changeIndex] = useState(null)
  const history = useHistory();
  useEffect(() => {
    getRelation(book?.relationships?.navigation?.index).then((data) => {
      changeIndex(data?.data[0]?.content.body)
    })
    // eslint-disable-next-line
  }, [])
  const nextUntil = (elem, selector, filter) => {
    // Setup siblings array
    const siblings = []

    // Get the next sibling element
    let elemNew = elem.nextElementSibling

    // As long as a sibling exists
    while (elemNew) {
      // If we've reached our match, bail
      if (elemNew.matches(selector)) break

      // If filtering by a selector, check if the sibling matches
      if (filter && !elemNew.matches(filter)) {
        elemNew = elemNew.nextElementSibling
      }

      // Otherwise, push it to the siblings array
      siblings.push(elemNew)

      // Get the next sibling element
      elemNew = elemNew.nextElementSibling
    }

    return siblings
  }

  const getElementsByText = (el, str) => {
    let indicator = 0
    if (el.classList.contains('letter') || ((el.textContent && el.textContent.toLowerCase().includes(str.toLowerCase())) ||
          (el.children.length === 0 && el.outerText && el.outerText.toLowerCase().includes(str.toLowerCase())))) {
      el.classList.remove('hidden')
      el.classList.add('show')
      indicator = 1
    } else {
      el.classList.remove('show')
      el.classList.add('hidden')
    }
    return indicator
  }
  const handleSearch = (e) => {
    setSearch(e.target.value)
    if (indexMenuData) {
      each(indexMenuData.current.querySelectorAll('.index > .letter'), (letter) => {
        let indicator = 0
        each(nextUntil(letter, '.letter'), (el) => {
          indicator += getElementsByText(el, e.target.value)
        })
        if (indicator) {
          letter.classList.remove('hidden')
          letter.classList.add('show')
        } else {
          letter.classList.remove('show')
          letter.classList.add('hidden')
        }
      })
    }
  }

  const a = []
  let i = 'a'.charCodeAt(0)
  const j = 'z'.charCodeAt(0)
  for (; i <= j; ++i) {
    a.push(String.fromCharCode(i))
  }
  const Menu = () => {
    return (
      <>
        {a.map((char) => {
          const select = indexMenuData?.current && indexMenuData.current.querySelector(`#letter-${char.toUpperCase()}`)
          const isExist = select && !select.classList.contains('hidden')

          // const isExist = selector.length && !selector.classList.contains('hidden')
          return (
            <div key={char}>
              {isExist ? <a
                href={`#letter-${char.toUpperCase()}`}
                onClick={() => {
                  const menuActivity = document.querySelector('.bookreader-mobile-nav .menu-index-content')
                  menuActivity.querySelector(`dt#letter-${char.toUpperCase()}`).scrollIntoView()
                }}
              >{char}
              </a> : char}
            </div>
          )
        })}
      </>
    )
  }

  /**
   * DUPLICATE CODE IN page.js
   */
  const linkClickEventHandler = (e) => {
    e.currentTarget.removeEventListener(e.type, linkClickEventHandler);

    if (get(book, 'id') === get(e.target, 'dataset.idBook')) {
      let subsectionType = get(e.target, 'dataset.subsectionType')
      let currentBookType = get(book, 'page_type')

      if (subsectionType !== currentBookType) {
        if (subsectionType === 'appendix') {
          setBook({...book, page_type: 'appendices'})
        }
        else {
          setBook({...book, page_type: 'chapters'})
        }
      }

      setPage(get(e.target, 'dataset.id'))
      setForceScroll(true)
      let targetUrl = get(e.target, 'url', get(book, 'url'))
      history.push(targetUrl)

      e.preventDefault()
      return false
    }

    return true
  }

  useEffect(() => {
    const links = indexMenuData.current.querySelectorAll('a[data-content-type="subsection"]')
    if (links.length) {
      each(links, (link) => {
        link.addEventListener('click', linkClickEventHandler, {once: true})
      })
    }
    // eslint-disable-next-line
  }, [index])
  // const { data: index } = indexMenuJSON
  return (
    <>
      {!navigationOnly &&
      <>
        <label>Search Index</label>
        <input
          type="text"
          className="index-search"
          value={search}
          onChange={handleSearch}/>
        <div className="menu-index"><Menu/></div>
      </>}

      <div
        className="menu-index-content"
        ref={indexMenuData}
        dangerouslySetInnerHTML={{ __html: index }}
      />
    </>
  )
}
export default IndexMenu
